import { render, staticRenderFns } from "./CertificationRepeater.vue?vue&type=template&id=225c4768&scoped=true&"
import script from "./CertificationRepeater.vue?vue&type=script&lang=js&"
export * from "./CertificationRepeater.vue?vue&type=script&lang=js&"
import style0 from "./CertificationRepeater.vue?vue&type=style&index=0&id=225c4768&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c4768",
  null
  
)

export default component.exports